/**
 * @param {Date} date
 */
export function idForDay(date) {
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

/**
 * @param {Date} a
 * @param {Date} b
 */
export function isSameDate(a, b) {
    if (!a || !b) {
        return !!a === !!b;
    }

    return a.getFullYear() === b.getFullYear() &&
       a.getMonth() === b.getMonth() &&
       a.getDate() === b.getDate();
}

/**
 * @param {Date} date
 * @param {string} format
 */
export function dateToString(date, format) {
    if (!date) {
        return '';
    }

    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString();
    const day = date.getDate().toString();

    return format
        .replace('YYYY', year)
        .replace('YYY', year.slice(1, 3))
        .replace('YY', year.slice(2, 3))
        .replace('MM', (month.length === 1 ? `0${month}` : month))
        .replace('M', month)
        .replace('DD', (day.length === 1 ? `0${day}` : day))
        .replace('D', day);
}

/**
 * @param {string} dateString
 * @param {string} format
 */
export function dateFromString(dateString, format) {
    const indexes = [
        { id: 'day', index: format.indexOf('D') },
        { id: 'month', index: format.indexOf('M') },
        { id: 'year', index: format.indexOf('Y') },
    ].sort((a, b) => a.index - b.index);

    const date = {};

    try {
        indexes.forEach(element => {
            dateString = dateString.replace(/(?:^|\D+)(\d+)(?:\D+|$)/, (_match, p1) => {
                date[element.id] = parseInt(p1);

                return '-';
            });
        });
    } catch (_e) {
        return null;
    }

    if (date.year !== undefined && date.month !== undefined && date.day !== undefined) {
        return new Date(date.year, date.month - 1, date.day);
    } else {
        return null;
    }
}
